logs-calendar
  div.form-inline
    input(class="form-control" type="text" value="{this.opts.day}")
    span &nbsp;の変更ログ
  script(type="typescript").
    this.mixin('logs.calendar')
  style(scoped).
    :scope { display: inline-block; }
